import client from "../utils/client";

export function upload({ file, type = "image" }: { file: File, type?: string }): Promise<{ path: string }> {
  const formData = new FormData();
  formData.append("file", file);
  // FIXME: upload api typo
  return client.post(`/uploud?type=${type}`, formData);
}
